
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

interface NavbarLogoProps {
  isDarkTheme: boolean;
}

const NavbarLogo = ({ isDarkTheme }: NavbarLogoProps) => {
  return (
    <Link to="/" className="flex items-center gap-2">
      <motion.div
        whileHover={{ scale: 1.1, rotate: 10 }}
        transition={{ duration: 0.3 }}
      >
        <img 
          src="/lovable-uploads/972bec05-de40-48f5-acd9-ad7503e6ee11.webp" 
          alt="Anzir Logo" 
          className="w-10 h-10" 
        />
      </motion.div>
      <span className={`font-bold text-xl ${isDarkTheme ? 'text-white' : 'text-gray-900'}`}>Anzir</span>
    </Link>
  );
};

export default NavbarLogo;
